// extracted by mini-css-extract-plugin
var _1 = "Card_attachment__KnwuL";
var _2 = "Card_attachmentLeft__jEyOp";
var _3 = "Card_attachments__-CgZV";
var _4 = "Card_attachmentsRight__Jazpc";
var _5 = "Card_card__zQfcO";
var _6 = "Card_cardNotifPop__vCfqP";
var _7 = "Card_cardOpen__zS98C";
var _8 = "Card_content__ASKh8";
var _9 = "Card_cover__Ss36Q";
var _a = "Card_details__wrmtl";
var _b = "Card_detailsIcon__wCvfX";
var _c = "Card_detailsNotification__6wbTI";
var _d = "Card_detailsTitle__IsX6U";
var _e = "Card_editCardButton__0U0o1";
var _f = "Card_labels__qJe5L";
var _10 = "Card_moreUsers__-BQQr";
var _11 = "Card_name__vpWb5";
var _12 = "Card_notification__eR7Sh";
var _13 = "Card_notificationFull__JcBBl";
var _14 = "Card_popupWrapper__3a-YJ";
var _15 = "Card_popupWrapper2__pqt-t";
var _16 = "Card_user__MeExM";
var _17 = "Card_users__lqZz3";
var _18 = "Card_wrapper__kLQpI";
export { _1 as "attachment", _2 as "attachmentLeft", _3 as "attachments", _4 as "attachmentsRight", _5 as "card", _6 as "cardNotifPop", _7 as "cardOpen", _8 as "content", _9 as "cover", _a as "details", _b as "detailsIcon", _c as "detailsNotification", _d as "detailsTitle", _e as "editCardButton", _f as "labels", _10 as "moreUsers", _11 as "name", _12 as "notification", _13 as "notificationFull", _14 as "popupWrapper", _15 as "popupWrapper2", _16 as "user", _17 as "users", _18 as "wrapper" }
